<template>

    <div>

        <div style="margin: 15px;">{{  text }}</div>
        <br />


        <div id="calendar-container">
            <div>
                <b-button variant="primary" id="new-item-button" v-b-modal.modal-1>New Item</b-button>

                <b-modal id="modal-1" title="New Item" @ok="createItem">

                    <b-form-group id="input-group-1" label="Title:" label-for="input-1">
                        <b-form-input id="input-1" v-model="form.title" placeholder="enter title" required></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Start Date:" label-for="input-2">
                        <b-form-input id="input-2" v-model="form.startDate" placeholder="" required></b-form-input>
                    </b-form-group>
                    
                    <b-form-group id="input-group-3" label="End DAte:" label-for="input-3">
                        <b-form-input id="input-3" v-model="form.endDate" placeholder="" required></b-form-input>
                    </b-form-group>                    

                </b-modal>
            </div>

            <calendar-view
                :show-date="showDate"
                :items="items"
                :enableDragDrop="enableDragDrop"
                @click-item="handleClickItem"
                @click-date="handleClickDate"
                @drop-on-date="handelDropOnDate"
                class="theme-default holiday-us-traditional holiday-us-official">
                <calendar-view-header
                    slot="header"
                    slot-scope="t"
                    :header-props="t.headerProps"
                    @input="setShowDate"
                    />
            </calendar-view>
        </div>

    </div>

</template>

<script>
    // reference https://www.npmjs.com/package/vue-simple-calendar/v/5.0.0?activeTab=readme#props
    import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"

    require("vue-simple-calendar/static/css/default.css")
    require("vue-simple-calendar/static/css/holidays-us.css")

    export default {
        name: 'CalendarTest',
        components: {
            CalendarView,
            CalendarViewHeader,
        },
        data: function () {
            return {
                text: "vue-simple-calendar v5.0.0",
                showDate: new Date(),
                enableDragDrop: true,
                form: {
                    title: "test 123",
                    startDate: "2024-06-01",
                    endDate: "2024-06-01",
                },
                items: [
                    {
                        id: '1',
                        startDate: '2024-06-01',
                        endDate: '2024-06-01',
                        title: 'Event 1',
                        classes: 'item-blue-category'
                    },
                    {
                        id: '2',
                        startDate: '2024-06-03',
                        endDate: '2024-06-05',
                        title: 'Event 2',
                        classes: 'item-green-category'
                    },
                    {
                        id: '3',
                        startDate: '2024-06-17',
                        endDate: '2024-06-19',
                        title: 'Event 3',
                        classes: 'item-orange-category'
                    },
                    {
                        id: '4',
                        startDate: '2024-06-21',
                        endDate: '2024-06-22',
                        title: 'Event 4',
                        classes: 'item-purple-category'
                    },
                    {
                        id: '5',
                        startDate: '2024-06-25',
                        endDate: '2024-06-27',
                        title: 'Event 5',
                        classes: 'item-red-category'
                    },
                    {
                        id: '6',
                        startDate: '2024-06-25',
                        endDate: '2024-06-29',
                        title: 'Event 6',
                        classes: 'item-yellow-category'
                    }                                                                                         
                ]
            };
        },
        mounted: async function () {
            // Display core vue app element
            const appElement = document.getElementById('app');
            appElement.style.display = 'block';
        },
        methods: {
            createItem() {
                var id = parseInt(this.items[this.items.length - 1].id) + 1;
                var title = this.form.title;
                var startDate = this.form.startDate;
                var endDate = this.form.endDate;
                var category = 'item-yellow-category';

                var item = {
                    id: id,
                    title: title,                    
                    startDate: startDate,
                    endDate: endDate,
                    classes: category               
                }

                this.items.push(item);
            },
            setShowDate(d) {
                this.showDate = d;
            },
            handleClickDate(date, calendarItem, windowEvent) {
                // Handle the click event here
                console.log("-- DATE CLICKED!");
                console.log('Date:', date);
                console.log('Calendar Item:', calendarItem);
                console.log('Window Event:', windowEvent);
            },
            handleClickItem(calendarItem, windowEvent) {
                // Handle the click event here
                console.log("-- ITEM CLICKED!");
                console.log('Calendar Item:', calendarItem);
                console.log('Window Event:', windowEvent);
            },
            handelDropOnDate(calendarItem, date, windowEvent) {
                console.log("-- DROPPED ON DATE!");
                console.log('Date:', date);
                console.log('Calendar Item:', calendarItem);
                console.log('Window Event:', windowEvent);
                console.log(calendarItem.id)

                // update Item start and end date
                for(var i=0; i < this.items.length; i++) {
                    if(this.items[i].id == calendarItem.id) {
                        // determine days length
                        var dayLength = this.daysBetweenDates(this.items[i].startDate, this.items[i].endDate);
                        // determine new start date
                        var newStartDate = this.formatDateToYYYYMMDD(date);
                        // determine new end date
                        var newEndDate = this.increaseDateByDays(newStartDate, dayLength);

                        this.items[i].startDate = newStartDate;
                        this.items[i].endDate = newEndDate;
                    }
                }
            },
            formatDateToYYYYMMDD(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            daysBetweenDates(date1, date2) {
                // Parse the dates
                const startDate = new Date(date1);
                const endDate = new Date(date2);

                // Calculate the difference in milliseconds
                const differenceInTime = endDate - startDate;

                // Convert the difference from milliseconds to days
                const differenceInDays = differenceInTime / (1000 * 3600 * 24);

                return differenceInDays;
            },
            increaseDateByDays(dateString, days) {
                // Parse the date string to a Date object
                const date = new Date(dateString);
                
                // Add the given number of days
                date.setDate(date.getDate() + days);
                
                // Format the date back to YYYY-MM-DD
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                
                return `${year}-${month}-${day}`;
            }                                  
        }
    }
</script>

<style>
    #new-item-button {
        margin-bottom: 20px;
    }

    .item-blue-category {
        background-color: #8baad9 !important;
    }

    .item-green-category {
        background-color: #8cd381 !important;
    }

    .item-orange-category {
        background-color: #f4ad6c !important;
    }    
    
    .item-purple-category {
        background-color: #95b8d1 !important;
    }        

    .item-purple-category {
        background-color: #a491d9 !important;
    }
    
    .item-red-category {
        background-color: #e19b9a !important;
    }      

    .item-yellow-category {
        background-color: #f9f076 !important;
    }      


    #calendar-container {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        color: #2c3e50;
        height: 67vh;
        width: 90vw;
        margin-left: auto;
        margin-right: auto;        
    }
</style>